import { Injectable } from '@angular/core';
import { BaseService, Pagination, PaginatedResponse, ORDER_BY_VALUE, OrderByValue, DialogData } from '../core';
import { Product, DisplayCategory, ProductListDto, ShippingService, Cart } from '../dto';
import { Store } from '@ngrx/store';
import * as IndicatorStore from '../store/indicator';
import { mergeMap } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { CERTIFICATION_TYPE, INCOTERMS } from '../shared';
import { CustomDialogComponent } from '../modules/resp/_component/custom-dialog/custom-dialog.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatDialog } from '@angular/material/dialog';
import { Injector } from '../core/injector/injector';
@Injectable({
  providedIn: 'root',
})
export class ProductService extends BaseService {
  DEFAULT_CLASSES = {
    badges: true,
    last: false,
    normal: false,
    wide: false,
    best: false,
  };

  private setSelectSubject = new Subject<any>(); // 이벤트 리스너
  setSelectOption$ = this.setSelectSubject.asObservable(); // 옵션 선택 이벤트 리스너

  private resetSubject = new Subject<any>(); // 이벤트 리스너
  resetSubject$ = this.resetSubject.asObservable(); // 초기화 이벤트 리스너

  private openOptionSubject = new Subject<any>(); // 이벤트 리스너
  openOptionSubject$ = this.openOptionSubject.asObservable(); // 선택 박스 오픈 이벤트 리스너

  private ControlFabSubject = new Subject<any>(); // 이벤트 리스너
  ControlFabSubject$ = this.ControlFabSubject.asObservable(); //모바일 전용 Fab 제어 이벤트 리스너

  selectProducts = []; // 일괄 선택 상품

  dialog: MatDialog;
  deviceDetector: DeviceDetectorService;

  public readonly maxProduct = 200; // 일괄 선택 최대 상품 등록수
  public cartsProductLength = 0;
  oneFlag = true;

  constructor(private store: Store<any>) {
    super();
  }
  getProduct(id: number) {
    return super.get<Product>(`/product/${id}`);
  }
  getProducts(productListDto: ProductListDto, paginate: Pagination) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('getProducts'));
    return super.paginate<Product>('/product', productListDto, paginate).pipe(
      mergeMap((pagenatedProduct) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('getProducts'));
        return of(pagenatedProduct);
      })
    );
  }

  getBrandHotProduct(brandId: number) {
    return super.get<Product[]>(`/product/brand-hot/${brandId}`);
  }

  getCategoryHotProduct(categoryId: number) {
    // const categoryMapper = {
    //   1: '009004001',
    //   33: '009004002',
    //   58: '009004003',
    //   81: '009004004',
    // };
    // const filter = new ProductListDto();
    // // filter.salesCategories = [categoryMapper[categoryId]];
    // filter.displayCategories = [categoryMapper[categoryId]];
    // filter.orderBySort = OrderByValue.ASC;
    // return super.get<Product[]>('/product/category-hot', filter);
    return super.get<Product[]>(`/product/category-hot/${categoryId}`);
  }

  // getNewArraivalHistory(paginate: Pagination) {
  //   return super.paginate<DisplayCategory>('/display-category/new-arrivals', paginate);
  // }

  getNewArraival() {
    return super.paginate<Product>('/new-arrivals/', new Pagination({ page: 0, limit: 100 }));
  }

  getCleanBeauty(productListDto: ProductListDto, paginate: Pagination) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('cancelPurchaseOrder'));
    return super.paginate<Product>('/clean-beauty', productListDto, paginate).pipe(
      mergeMap((pagenatedProduct) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('cancelPurchaseOrder'));
        return of(pagenatedProduct);
      })
    );
  }

  getCpnp(productListDto: ProductListDto, paginate: Pagination) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('cancelPurchaseOrder'));
    return super.paginate<Product>('/cpnp', productListDto, paginate).pipe(
      mergeMap((pagenatedProduct) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('cancelPurchaseOrder'));
        return of(pagenatedProduct);
      })
    );
  }

  getUnderTen(productListDto: ProductListDto, paginate: Pagination) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('cancelPurchaseOrder'));
    productListDto.orderBySaleSupplyPrice = OrderByValue.ASC;
    return super.paginate<Product>('/under-ten', productListDto, paginate).pipe(
      mergeMap((pagenatedProduct) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('cancelPurchaseOrder'));
        return of(pagenatedProduct);
      })
    );
  }

  getClearance(productListDto: ProductListDto, paginate: Pagination) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('cancelPurchaseOrder'));
    return super.paginate<Product>('/clearance', productListDto, paginate).pipe(
      mergeMap((pagenatedProduct) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('cancelPurchaseOrder'));
        return of(pagenatedProduct);
      })
    );
  }

  getBest() {
    return super.paginate<Product>('/product/best', new Pagination({ page: 0, limit: 100 }));
  }

  // getUmmaPick() {
  //   return super.paginate<Product>('/product/umma-pick', new Pagination({ page: 0, limit: 100 }));
  // }

  shippingAvailableCountry(productId: string | number, productOptionId: number, countryCode: string) {
    return super.get<ShippingService[]>(
      `/product/${productId}/option/${productOptionId}/shipping-service/${countryCode}`
    );
  }

  makeShippingAvailableCountryForDisplay(shippingServices: ShippingService[]): [string[], string] {
    const shippingServiceMap = shippingServices.reduce((acc, shippingService) => {
      if (!acc[shippingService.incoterms]) {
        acc[shippingService.incoterms] = [];
      }
      acc[shippingService.incoterms].push(shippingService.serviceCode);
      return acc;
    }, {});

    return [
      Object.keys(shippingServiceMap),
      Object.keys(shippingServiceMap)
        .map((key) => {
          return shippingServiceMap[key].length > 1 || key === INCOTERMS.DAP ? shippingServiceMap[key].join(', ') : key;
        })
        .join(', '),
    ];
  }

  makeShippingAvailableIncotermsForDisplay(shippingServices: ShippingService[]): [string[], string] {
    const shippingServiceMap = shippingServices.reduce((acc, shippingService) => {
      if (!acc[shippingService.incoterms]) {
        acc[shippingService.incoterms] = [];
      }
      return acc;
    }, {});

    return [
      Object.keys(shippingServiceMap),
      Object.keys(shippingServiceMap)
        .map((key) => {
          return key;
        })
        .join(', '),
    ];
  }

  mergeInvalidCountry(product: Product) {
    product.mapperSaleProducts.map((saleProduct) => {
      product.brand.invalidCountry = [
        ...new Set([
          ...product.brand.invalidCountry,
          ...saleProduct.productOption.brand.invalidCountry,
          ...saleProduct.productOption.invalidCountry,
        ]),
      ];
    });

    return product;
  }

  downloadInventoryExcel() {
    return this.downloadExcel(`/inventory/download/excel`);
  }

  // 상품 담을때
  emitSelectProduct() {
    this.setSelectSubject.next('add');
  }

  // 상품 초기화
  emitResetProduct(products?) {
    this.resetSubject.next(products);
  }

  // 옵션 모달 닫기 및 fab 버튼 닫기
  emitCloseModal() {
    this.openOptionSubject.next({ open: true });
    this.ControlFabSubject.next(false);
  }

  // 일괄 상품 담는 기능
  addToSelect(product) {
    if (!product.optionCheck) {
      if (this.cartsProductLength + this.selectProducts.length >= this.maxProduct) {
        const dialog = this._openDialog({
          message: `Cannot hold any more. Maximum of ${this.maxProduct} can be held.`,
          close: () => {
            dialog.close();
          },
        });
        return;
      }
      product.addBulkChecked = true;
      if(!this.selectProducts.map(selectProduct => selectProduct.id).includes(product.id)){
        this.selectProducts.push(product);
      }
    } else {
      this.selectProducts = this.selectProducts.filter((productSelect) => {
        return productSelect.id !== product.id;
      });
    }
    if (this.oneFlag && this.selectProducts.length > 0) {
      this.oneFlag = false;
      this.ControlFabSubject.next(true);
    }
    product.optionCheck = !product.optionCheck;
    this.emitSelectProduct();
    return product.optionCheck;
  }

  /**
   * @praram data:DialogData
   */
  protected _openDialog(data: DialogData) {
    this.deviceDetector = Injector.get(DeviceDetectorService);
    this.dialog = Injector.get(MatDialog);
    let userDeviceInfo = this.deviceDetector.getDeviceInfo() ? 'pc' : 'mobile';
    console.log(this.deviceDetector.getDeviceInfo());
    const config = {
      height: 'auto',
      panelClass: [userDeviceInfo, 'dialog'],
      data,
    };
    const dialog = this.dialog.open(CustomDialogComponent, config);
    return dialog;
  }
}
